import { Modal } from '@orcar/common-d2c';
import styled, { keyframes } from 'styled-components';

/**
 * 차량 선택 후 사전예약을 생성하고 결제 페이지로 이동하기까지의 짧은 대기 동안
 * 노출하는 전체 화면 로딩 오버레이. (차량 상세 페이지 제거로 선택 즉시 예약이
 * 생성되므로 중복 선택을 막고 진행 상태를 알린다.)
 */
const ReserveLoadingOverlay = () => {
  return (
    <Modal hasClose={false} topLevel scrollY={0}>
      <Wrapper>
        <Spinner />
        <LoadingText>예약 정보를 확인하고 있어요</LoadingText>
      </Wrapper>
    </Modal>
  );
};

export default ReserveLoadingOverlay;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  position: absolute;
  display: grid;
  justify-items: center;
  grid-gap: 24px;
  top: 45%;
  left: 50%;
  transform: translateX(-50%);
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: ${({ theme }) => theme.COLOR.WHITE};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const LoadingText = styled.p`
  ${({ theme }) => theme.FONT.H4};
  color: ${({ theme }) => theme.COLOR.WHITE};
  white-space: nowrap;
`;
